//@flow
/**
 * Socket utils.
 * @module utils/socket
 */
import io from "socket.io-client";
// import config from '../config';
// import history from 'utils/history'
import { getServerHost } from "./deployment";
import qs from "qs";

let retry = 0;
// const apiHost = `${config.api.protocol}://${config.api.host}:${config.api.port}`;
const apiHost = getServerHost();
let socket = io(apiHost, {
  path: window.location.hostname === "localhost" ? "" : "/websocket/socket.io/",
  transports: ['websocket']
});
const publicUrl = process.env.PUBLIC_URL;

socket.on("connect_error", function () {
  console.log("Connection Failed", retry);

  // remove the first letter of the params which is ?
  let urlParams = window.location.search;
  if (urlParams && urlParams !== '') {
    urlParams = urlParams.slice(1);
  }

  if (retry < 5) {
    retry++;
    socket = io(apiHost);

    if (window.location.pathname === `${publicUrl}/`) {
      window.location.assign(`${publicUrl}/error?client-not-found${urlParams !== '' ? `&${urlParams}` : ''}`);
    }
    return;
  }
  socket.disconnect();
  if (window.location.pathname !== `${publicUrl}/error`) {
    window.location.assign(`${publicUrl}/error?client-not-found${urlParams !== '' ? `&${urlParams}` : ''}`);
  }
});

socket.on("connect", function () {
  retry = 0;

  const { invite, quizId } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  if (
    window.location.pathname === `${publicUrl}/error` &&
    window.location.search !== "?invalid-invite"
  ) {
    // if both quizId and invite set
    if (quizId && invite) {
      window.location.assign(`${publicUrl}/?quizId=${quizId}&invite=${invite}`);
    } else if (quizId) { // if only quiz Id
      window.location.assign(`${publicUrl}/?quizId=${quizId}`);
    } else if (invite) { // if only invite
      window.location.assign(`${publicUrl}/?invite=${invite}`);
    }else {
      window.location.assign(`${publicUrl}/`);
    }
  }
});
// socket.on('disconnect', function () {
//   console.log('Disconnected');
// });

socket.on("error", (error) => {
  if (error === "No such deployment") {
    console.log("No such deployment");
    if (window?.location?.pathname !== "/client-not-found") {
      return window.location.assign("/client-not-found");
    }
    return false;
  }
  if (error.type === "UnauthorizedError" || error.code === "invalid_token") {
    //TODO: handle Unauthorized Errors
    throw error;
  }
  throw error;
});

/**
 * Wrapper for emitting an event to the server.
 * @memberof utils/socket
 */
export async function emit(eventName, eventData, retryCount = 0) {
  return new Promise((resolve, reject) => {
    socket.emit(eventName, eventData, async (err, result) => {
      if (err) {
        let token = localStorage.getItem("serviceToken");
        if (
          err.toLowerCase().includes("token not provided") &&
          retryCount < 2 &&
          token
        ) {
          await emit("auth:set-token", { token });
          const cnt = retryCount++;
          const retrySubmit = await emit(eventName, eventData, cnt);

          if (retrySubmit) {
            resolve(retrySubmit);
          }
        }
        return reject(err);
      }
      return resolve(result);
    });
  });
}

/**
 * Wrapper for listening to events from the server.
 * @memberof utils/socket
 */
export async function on(...args) {
  return socket.on(...args);
}

/**
 * Removes listeners defined in {@link #utils/socketon on.}
 * @memberof utils/socket
 */
export async function off(...args) {
  return socket.off(...args);
}
